class PayType {
    static VISA = 1
    static MASTER = 2
    static WECHAT = 3
    static ALIPAY = 4
    static PAYPAL = 5
    static RECHARGE = 6
}

export default PayType



// WEBPACK FOOTER //
// ./src/lib/PayType.js